import { userApiClient } from '@/setup/api'

export function useB2bFormMutation() {
    return userApiClient.useMutation('post', '/web/b2b-form')
}
